import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { VariableAccountType } from './VariableAccountType';
import { putAccountType } from '../../../../store/Actions/ActionAccountType';

function EditAccountType({ arr, open, setOpen }) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableAccountType();
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putAccountType(arr.id, state, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_account_type')}</p>
                </div>
                <div style={{ marginTop: "-10px" }} >
                    <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
                </div>
            </div>
        </RModal>
    );
}

export default EditAccountType;

